import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  props: {
  dialogProps: {
    type: Object,
    required: true,
  },
  dialog: {
    type: Object,
    required: true,
  },
  resolve: {
    type: Function,
    required: true,
  },
  reject: {
    type: Function,
    required: true,
  },
},
  setup(__props) {

const props = __props



const onClose = (...args: any) => {
  props.resolve(...args)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.dialog), _mergeProps({ onDialogClose: onClose }, __props.dialogProps), null, 16))
}
}

})